import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { Dictionary, TsButtonModule, TSIconModule } from 'tsui';

@Component({
  standalone: true,
  imports: [MatIconModule, TSIconModule, TsButtonModule, TSIconModule, RouterModule],
  template: `
    @if (showOpenDetails) {
      @if (url) {
        <a [routerLink]="url" [queryParams]="queryParams"><ts-icon icon="open_in_new"></ts-icon></a>
      } @else {
        <ts-button type="icon" color="accent" icon="open_in_new" (buttonClick)="onClick()"></ts-button>
      }
    }
  `,
})
export class TableOpenDetailsRendererComponent implements ICellRendererAngularComp {
  params: ICellRendererParams & {
    onOpenDetails?: (data: unknown) => void;
    openDetailsLinkBuilder?: (data: unknown) => { url: string; queryParams?: Dictionary<string> };
  };
  url: string;
  queryParams: Dictionary<string> = {};

  get showOpenDetails(): boolean {
    if (this.params?.node?.rowPinned) {
      return false;
    }

    if (this.params?.data?._rowType === 'group' || this.params?.node?.group) {
      return false;
    }

    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    if (this.params.openDetailsLinkBuilder) {
      const link = this.params.openDetailsLinkBuilder(this.params.data);
      this.url = link.url;
      this.queryParams = link.queryParams ?? {};
    }
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  onClick(): void {
    if (this.params?.onOpenDetails) {
      this.params.onOpenDetails(this.params.data);
    }
  }
}
